import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { CircularProgress, Container, Grid } from "@mui/material";

import { fundRaiserPageAction } from "../../store/actions";
import { EmptyDataDiv, PageListCard } from "../../components";
import { FundraisersListSkeleton } from "../../components/skeletons";
import { useNonInitialEffect } from "../../hooks/UseNonInitialEffect";

export default function () {
    const [loadingPages, setLoadingPages] = useState(false);
    const [state, setState] = useState({ limit: 9, offset: 0 });
    
    const dispatch = useDispatch();

    const campaignDetails = useSelector(state => state.fundraiser_page.campaign_details);
    const fundraisersList = useSelector(state => state.fundraiser_page.fundraisers_by_campaign.pages);
    const totalFundraisers = useSelector(state => state.fundraiser_page.fundraisers_by_campaign.total);

    const mapFundraiserPages = () => {
        return fundraisersList.map(list => {
            return <Grid key={list.id} item xs={6} sm={4}>
                <PageListCard page={list} key={list.id} />
            </Grid>
        })
    }

    const loadMorePages = async () => {
        setState({
            ...state,
            offset: state.offset + state.limit
        })
    }

    useEffect(() => {
        setLoadingPages(true);
        dispatch(fundRaiserPageAction.getFundraisersByCampaign(campaignDetails.event_id, state.limit, state.offset));
    }, [])

    useNonInitialEffect(() => {
        dispatch(fundRaiserPageAction.getFundraisersByCampaign(campaignDetails.event_id, state.limit, state.offset));
    }, [state.offset])

    useNonInitialEffect(() => {
        if (fundraisersList.length >= 0)
            setLoadingPages(false);

    }, [fundraisersList])

    return <Container className="CampaignFundraisersContainer">
        {
            fundraisersList.length ? (
                <InfiniteScroll
                    dataLength={fundraisersList.length} //This is important field to render the next data
                    next={loadMorePages}
                    hasMore={fundraisersList.length < totalFundraisers}
                    loader={<div style={{ textAlign: "center" }}><CircularProgress thickness={2} /></div>}
                >
                    <Grid container justifyContent="space-between" spacing={{ xs: 0, sm: 4 }}>
                        {mapFundraiserPages()}
                        {/* Added the following item to balance the UI if a row contains two records */}
                        <Grid item xs={6} sm={4}></Grid>
                    </Grid>

                </InfiniteScroll>
            ) : loadingPages ? <FundraisersListSkeleton /> : <EmptyDataDiv message="No fundraisers found for this campaign" />
        }
    </Container>
}